export enum FeatureModule {
  // 9 AppModule (zgodne z app-module.config.ts)
  SUPPORT = 'SUPPORT',
  AGENT = 'AGENT',
  MARKETING = 'MARKETING',
  MASSIVE_FILES = 'MASSIVE_FILES',
  PRODUCT = 'PRODUCT',
  ORDERS = 'ORDERS',
  CRM = 'CRM',
  SRM = 'SRM',
  ANALYTICS = 'ANALYTICS',
  // instance-config (custom, poza 9 AppModule)
  STORAGE_MODULE = 'STORAGE_MODULE',
  INTEGRATIONS_MODULE = 'INTEGRATIONS_MODULE',
}
